import './facebook-loader.jquery.scss'
import itemHtml from './facebook-loader.jquery.html'

export default class FacebookLoader {
	constructor(itemsCount) {
		this.itemsCount = itemsCount || 1;
		var items = '';
		for (var i = 0; i < this.itemsCount; i++) {
			items += itemHtml;
		}
		this.html = '<div class="fb-loading">' + items + '</div>';
		this.$element = $(this.html);
	}
}
